/**
 * EmptyState
 *
 * Props:
 *   icon      – emoji veya string  (default: '📭')
 *   text      – gösterilecek mesaj  (default: 'Kayıt bulunamadı')
 *   as        – 'div' | 'td'        (default: 'div')
 *               'td' modunda <tr><td colSpan={colSpan}> içine sarar
 *   colSpan   – as='td' olduğunda <td> colSpan değeri  (default: 100 → tüm sütunlar)
 *   className – ek class'lar wrapper'a eklenir
 *
 * Kullanım örnekleri:
 *
 *   // Kart/liste içinde:
 *   <EmptyState icon="🛌" text="ARANAN KRİTERDE ODA BULUNAMADI" />
 *
 *   // Tablo içinde:
 *   <EmptyState as="td" colSpan={6} icon="🧾" text="Kayıt bulunamadı" />
 */

export default function EmptyState({
  icon = '📭',
  text = 'Kayıt bulunamadı',
  as = 'div',
  colSpan = 100,
  className = '',
}) {
  const content = (
    <div className={`py-20 flex flex-col items-center justify-center gap-4 text-center ${className}`}>
      <div className="text-6xl grayscale opacity-20 select-none">{icon}</div>
      <p className="text-[10px] font-black text-gray-300 uppercase tracking-widest italic">
        {text}
      </p>
    </div>
  );

  if (as === 'td') {
    return (
      <tr>
        <td colSpan={colSpan} className="p-0">
          {content}
        </td>
      </tr>
    );
  }

  return content;
}
